import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { painCards } from '../data/content';
export function PainPoints() {
  return <section id="verdad" className="w-full scroll-mt-16 bg-forest py-16 sm:py-20" data-id="element-144" data-mp="2lpezgr1q3w56">
      <div className="mx-auto max-w-6xl px-5 sm:px-6" data-id="element-145" data-mp="26y619tjr92gf">
        <Reveal className="text-center" data-id="element-146" data-mp="2bwr1hsz0bm4v">
          <p className="text-[13px] font-semibold uppercase tracking-[0.2em] text-gold" data-id="element-147" data-mp="2bvocxrp5pvs4">
            La verdad que nadie te está diciendo
          </p>

          <h2 className="mx-auto mt-4 max-w-3xl text-[30px] font-bold leading-[1.08] tracking-tight text-white sm:text-[44px]" data-id="element-148" data-mp="21zuszn93z00b">
            Lo que comes cada día está llenando tu cuerpo de invasores invisibles.
          </h2>

          <p className="mx-auto mt-4 max-w-2xl text-[17px] italic leading-relaxed text-gold sm:text-lg" data-id="element-149" data-mp="1szg3ebp42yr0">
            Y la solución no está en comer menos — está en limpiar lo que ya está dentro.
          </p>

          <p className="mx-auto mt-6 max-w-[680px] text-[17px] font-normal leading-relaxed text-white/85 sm:text-lg" data-id="element-150" data-mp="3nc5yuxv4og0i">
            El 73% de los alimentos que compramos en supermercados son ultraprocesados. Están
            diseñados para durar años en un estante — y eso tiene un precio biológico que nadie te
            explica en la etiqueta.
          </p>
        </Reveal>

        <ul className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-151" data-mp="23sg9ga3g8kt8">
          {painCards.map(({
          icon: Icon,
          statement,
          detail
        }, i) => <Reveal as="li" key={statement} delay={i * 0.08} className="flex h-full flex-col items-center rounded-xl bg-forest-light p-6 text-center ring-1 ring-white/5" data-id="element-152" data-mp="1b2zkxniy9o2a" data-mpi={i}>
              <Icon className="h-12 w-12 shrink-0 text-gold" strokeWidth={1.4} aria-hidden="true" data-id="element-153" data-mp="1p0egl9zsqs2p" />
              <p className="mt-4 text-[20px] font-bold leading-snug text-white sm:text-[22px]" data-id="element-154" data-mp="1k5iibs3yv8h5">
                {statement}
              </p>
              <p className="mt-auto pt-3 text-sm leading-relaxed text-white/55" data-id="element-155" data-mp="2vjcmpbtf8rh1">{detail}</p>
            </Reveal>)}
        </ul>

        <Reveal delay={0.1} className="text-center" data-id="element-156" data-mp="1t4dhh4ipvc9d">
          <p className="mx-auto mt-10 max-w-2xl text-[18px] italic leading-relaxed text-gold sm:text-xl" data-id="element-157" data-mp="1y3zr73zc6adf">
            No es tu culpa. El sistema alimentario moderno te puso en desventaja. Nosotros te damos
            las herramientas para recuperar el control.
          </p>

          <p className="mt-6 inline-flex items-center gap-2 rounded-full bg-white px-5 py-2.5 text-left text-[14px] font-semibold text-forest sm:text-[15px]" data-id="element-158" data-mp="272k57rtybvvb">
            <CheckIcon className="h-4 w-4 shrink-0 text-forest" aria-hidden="true" data-id="element-159" data-mp="1eh236uv5he5k" />
            La solución: eliminarlos de forma natural, sin fármacos agresivos.
          </p>
        </Reveal>
      </div>
    </section>;
}